import {useCallback, useEffect, useState} from 'react';

export const useImage = (src = '') => {
    const [isLoaded, setLoaded] = useState(false);
    const [isError, setError] = useState(false);

    useEffect(() => {
        if (!src) {
            return;
        }

        const handleLoad = () => setLoaded(true);
        const handleError = () => setError(true);

        const img = document.createElement('img');

        img.addEventListener('load', handleLoad);
        img.addEventListener('error', handleError);
        img.src = src;

        return () => {
            img.removeEventListener('load', handleLoad);
            img.removeEventListener('error', handleError);
        };
    }, [src]);

    return {
        isLoaded,
        isError,
    };
};

export const useImageByRef = () => {
    const [isLoaded, setLoaded] = useState(false);
    const [isError, setError] = useState(false);
    const [imageNode, setImageNode] = useState<HTMLImageElement | null>(null);

    useEffect(() => {
        if (!imageNode) {
            return;
        }

        const handleLoad = () => setLoaded(true);
        const handleError = () => setError(true);

        imageNode.addEventListener('load', handleLoad);
        imageNode.addEventListener('error', handleError);

        return () => {
            imageNode.removeEventListener('load', handleLoad);
            imageNode.removeEventListener('error', handleError);
        };
    }, [imageNode]);

    const setImageRef = useCallback((node: HTMLImageElement) => {
        setImageNode(node);
    }, []);

    return {
        setImageRef,
        isLoaded,
        isError,
    };
};
